<template lang="html">
  <div class="container-fluid">
    <div class="row">
      <div class="col-7">
        <div class="card">
          <div class="card-body">
            <select v-model="filter.status" @change="applyStatusFilter">
              <option value="rejected">Zahlung fehlgeschlagen</option>
              <option value="paid" selected="selected">Bezahlt</option>
              <option value="synced">Synchronisiert</option>
            </select>
            <table class="table table-responsive table-hover table-stripe">
              <tr>
                <th>ID</th>
                <th>V-No</th>
                <th>Veranstaltungstitel</th>
                <th>Status</th>
                <th>Kunde</th>
                <th>Datum</th>
                <th v-if="filter.status != 'rejected'">Zahlweise</th>
                <th>Summe</th>
              </tr>
              <tr v-for="(enrollment, index) in enrollments" @click="selectEnrollment(index)" v-bind:class="{ activeAdminRow: index == selectedIndex}">
                <td>{{enrollment.id}}</td>
                <td>{{enrollment.vno}}</td>
                <td>{{enrollment.seminarTitle}}</td>
                <td>{{enrollment.status}}</td>
                <td>{{enrollment.participants[0].firstname}} {{enrollment.participants[0].lastname}}</td>
                <td>{{enrollment.created_at | moment("DD.MM.YY HH:mm")}}</td>
                <td v-if="filter.status != 'rejected'">
                  <span v-if="enrollment.paymentDetails.brand == 'DIRECTDEBIT_SEPA'">SEPA</span>
                  <span v-if="enrollment.paymentDetails.brand != 'DIRECTDEBIT_SEPA' && enrollment.paymentDetails.brand != ''">CC</span>
                  </td>
                <td>{{enrollment.totalPrice | stringifyNumber(',', 2)}}</td>
              </tr>
            </table>
            <b-pagination
              align="center"
              :total-rows="pagination.totalItems"
              :per-page="pagination.itemsPerPage"
              v-model="pagination.currentPage"
              @input="pagination.onChange"
            ></b-pagination>
          </div>
        </div>
      </div>
      <div class="col-5">
        <div class="card">
          <div class="card-header">
            <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
              <button
              type="button"
              class="btn btn-light"
              :disabled="!selected"
              @click="showForwardEnrollmentConfirmation">
                <font-awesome-icon icon="share"/>
                Weiterleiten an..
              </button>
              <button type="button" class="btn btn-light" :disabled="!selected" @click="resendConfirmation">
                <font-awesome-icon icon="envelope"/>
                Bestätigungsmail versenden
              </button>
            </div>
          </div>
          <div class="card-body" v-if="selected">
            <div v-if="selected.status == 'synced'" class="alert alert-success" role="alert">
              Diese Veranstaltung wurde bereits verarbeitet und versendet an: {{selected.syncedEmail}}
            </div>
            Anmeldung eingegangen: {{selected.created_at | moment("DD.MM.YY HH:mm")}} Uhr
            <div class="row">
              <div class="col-12">
                <h5>{{selected.seminarTitle}}</h5>
                <h6>Anmelder und Zahler</h6>
                {{selected.customer.gender}}<br/>
                {{selected.customer.firstname}} {{selected.customer.lastname}}
                <div class="row">
                  <div class="col">
                    {{selected.customer.address.street}} <br />
                    {{selected.customer.address.postalcode}} {{selected.customer.address.city}}
                  </div>
                  <div class="col" v-if="selected.invoiceAddressId != selected.customer.address.id">
                    <b>Abweichende Rechnungsanschrift</b>
                    {{selected.invoiceAddress.street}} <br />
                    {{selected.invoiceAddress.postalcode}} {{selected.invoiceAddress.city}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12" v-if="selected.paymentDetails != null && selected.paymentDetails.transaction.code == '000.000.000'">
                <h4>Zahlung</h4>
                <div v-if="selected.paymentDetails.brand != 'DIRECTDEBIT_SEPA'" class="ccard">
                  <span>{{selected.paymentDetails.brand}}</span><br />
                  <span class="cardnumber">**** **** **** {{selected.paymentDetails.additional.card.last4Digits}}</span><br />
                  <span>{{selected.paymentDetails.additional.card.holder}}</span><br />
                  <span>{{selected.paymentDetails.additional.card.expiryMonth}} / {{selected.paymentDetails.additional.card.expiryYear}}</span>
                </div>
                <div v-else>
                  SEPA
                </div>
                <!-- <button class="btn btn-light" @click="getInvoice">
                  <font-awesome-icon icon="file-pdf"></font-awesome-icon> Rechnung herunterladen
                </button>
                -->
              </div>
              <div class="col-12" v-else>
                <br/>
                <div v-if="selected.paymentDetails != null">
                    <h4>VRPAY Fehlermeldung</h4>
                  Code: {{selected.paymentDetails.transaction.code}}<br/>
                  Meldung: {{selected.paymentDetails.transaction.description}}<br/>
                  <br/>
                  </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h4>Angemeldete Personen</h4>
                <div class="list-group">
                  <div v-for="(participant, index) in selected.participants" class="list-group-item list-group-item-action flex-column align-items-start">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{participant.firstname}} {{participant.lastname}}</h5>
                      <small v-if="selected.overnightSelectionRequired == 1">{{(participant.overnight) ? 'Mit' : 'Ohne'}} Übernachtung</small>
                    </div>
                    <p class="mb-1">
                      {{participant.address.street}} <br />
                      {{participant.address.postalcode}} {{participant.address.city}}
                    </p>
                    <span v-for="discount in participant.discounts" class="text-danger">{{discount.label}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template>
      <div>
        <b-modal ref="confirmForward" title="Datei verschicken" @hide="onModalHide">
          <input class="form-control" placeholder="Email-Adresse" v-model="forwardConfirmationForm.forwardEmail"/>
          <div slot="modal-footer" class="w-100">
              <b-btn size="sm" variant="light" class="float-right">Abbrechen</b-btn>&nbsp;
              <b-btn size="sm" class="float-right" variant="primary" :disabled="sendingMail" @click="modalButtonHandler">
                Veranstaltung als Email versenden
              </b-btn>
        </div>
        </b-modal>
      </div>
    </template>
  </div>
</template>

<script>
import API from '@/lib/api'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
export default {
  name: 'EnrollmentList',
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      sendingMail: false,
      enrollments: [],
      selected: null,
      selectedIndex: null,
      forwardConfirmationForm: {
        forwardEmail: 'akademie@tma-bensberg.de'
      },
      filter: {
          status: 'paid'
      },
        pagination: {
            itemsPerPage: 20,
            totalItems: 0,
            currentPage: 0,
            onChange: this.paginationChangeHandler
        }
    }
  },
  computed: {
    status() {
      return "test"
    }
  },

  async mounted() {
    await this.loadEnrollments();
  },

  methods: {
    async loadEnrollments(page = 1) {
      let result = await API.get('/enrollments?status=' + this.filter.status + '&p=' + page)
      this.enrollments = result.data.data
        this.pagination.totalItems = result.data.total
        this.pagination.currentPage = page
        this.selectedIndex = null
    },
    async applyStatusFilter(event) {
        await this.loadEnrollments(1)
    },
    onModalHide (event) {
      if(event.trigger != 'ok') {
      //  event.preventDefault();
      }
      //this.forwardConfirmationForm.forwardEmail = ""
    },
    async paginationChangeHandler (page) {
        let result = await this.loadEnrollments(page)
    },
    async modalButtonHandler() {
      this.sendingMail = true;
      await API.post('/enrollments/' + this.selected.id + '/redirect', {
        email: this.forwardConfirmationForm.forwardEmail
      })
      this.sendingMail = false;
      this.$refs.confirmForward.hide('ok');
      this.loadEnrollments();
      this.selected = this.enrollments[this.selectedIndex];
    },
    showForwardEnrollmentConfirmation() {
      this.$refs.confirmForward.show()
    },
    selectEnrollment(index) {
      this.selectedIndex = index;
      this.selected = this.enrollments[index];
    },
    sendSyncMail() {

    },
      async getInvoice() {

        let invoicedata = await API.get('/enrollments/' + this.selected.id + '/invoice', {
           responseType: 'blob'
        })

        const url = window.URL.createObjectURL(new Blob([invoicedata.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', invoicedata.headers['x-filename']);
          document.body.appendChild(link);
          link.click();

          this.$snotify.success('Rechnung wird heruntergeladen.');
      },
      async resendConfirmation() {
        await API.post('/enrollments/' + this.selected.id + '/confirmation')
          this.$snotify.success('Die Bestätigungsemail wurde erneut an den Kunden gesendet!');
      }
  }
}
</script>

<style lang="css">
.ccard {
  width: 50.5mm;
  height: 30mm;
  color: #fff;
  font: 12px/1 'Iceland', monospace;
  background: #222;
  border: 1px solid #1e1584;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin: 20px 0px;
  box-shadow: 0px 0px 3px 1px rgba(0,0,0,0.4);
  padding: 20px;
  overflow: hidden;
}
.activeAdminRow {
  background-color:#ffffcc;
}

</style>



// WEBPACK FOOTER //
// src/views/admin/EnrollmentsList.vue